import { render, staticRenderFns } from "./DraftEditorWidgetsTools.vue?vue&type=template&id=7001fa66&scoped=true&"
import script from "./DraftEditorWidgetsTools.vue?vue&type=script&lang=js&"
export * from "./DraftEditorWidgetsTools.vue?vue&type=script&lang=js&"
import style0 from "./DraftEditorWidgetsTools.vue?vue&type=style&index=0&id=7001fa66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7001fa66",
  null
  
)

export default component.exports